import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import { Title } from 'builder/components/AutoTailoring/AutoTailoringModal/styles'
import Typography from 'builder/styles/typography'

export const StyledTitle = styled(Title)`
  ${Typography.S};
`

export const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: ${Colors.Indigo20};
`
